import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from 'styles/input.scss';
import S from 'styles/form.scss';
import { Checkbox } from 'react-toolbox';

const CheckBox = ({ label, text, onChange, className, errors, checked }) => {
  const errorMsg = errors.join(', ');
  const wrapperStyles = errorMsg ? cx(styles.errored, className) : className;
  const labelStyles = errorMsg ? cx(S.label, S.errorLabel) : S.label;

  return (
    <div className={wrapperStyles}>
      <h6 className={labelStyles}>{label}</h6>
      <Checkbox
        checked={checked}
        label={text}
        onChange={onChange}
      />
      {errorMsg &&
        <div className={styles.error}><p className={S.errorMsg}>{errorMsg}</p></div>}
    </div>
  );
};

CheckBox.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  errors: PropTypes.array.isRequired,
  className: PropTypes.string,
};

CheckBox.defaultProps = {
  label: '',
  text: '',
  errors: [],
};

export default CheckBox;



// WEBPACK FOOTER //
// ./client/app/shared/components/CheckBox/index.jsx